import { format } from "date-fns";
import React from "react";

interface DateCellProps {
  date: Date;
}

export const DateCell: React.FC<DateCellProps> = ({ date }) => {
  const timeString = format(date, "HH:mm");
  const dateString = format(date, "dd.MM.yyyy");

  return (
    <div className="flex flex-col">
      <span>{dateString}</span>
      <span>{timeString}</span>
    </div>
  );
};
